import { Component, OnInit } from "@angular/core";
import { City, FirebaseService, Venue } from "src/app/core";
import { FormGroup, FormControl } from "@angular/forms";
import {
  MDBModalRef,
  MDBModalService,
  ToastService
} from "ng-uikit-pro-standard";
import { ConfirmCityComponent } from "../../popups/confirm-city/confirm-city.component";

@Component({
  selector: "ll-add-venue-form",
  templateUrl: "./add-venue-form.component.html",
  styleUrls: ["./add-venue-form.component.scss"]
})
export class AddVenueFormComponent implements OnInit {
  venue: Venue;
  image = "";
  title = "Add Venue";
  button = "Add";
  form: FormGroup;
  constructor(
    public fb: FirebaseService,
    private toast: ToastService,
    public modalRef?: MDBModalRef
  ) {
    this.form = new FormGroup({
      venue_name: new FormControl(""),
      active: new FormControl(true),
      redirect: new FormControl(false),
      sd: new FormControl(""),
      ld: new FormControl(""),
      redirect_url: new FormControl("")
    });
  }

  get city(): string {
    return this.fb.city.api.getId(this.fb.city.current);
  }

  ngOnInit() {}

  imageSelected = (): boolean => this.image != "";

  validate() {
    //Step 1: Valid Venue Name?
    if (
      this.form.controls.venue_name.value == "" ||
      !this.isValid(this.form.controls.venue_name.value.toLowerCase())
    )
      return this.error("Please provide a valid venue name!");

    //Step 2: Provided valid image?
    if (this.image == "")
      return this.error("Please provide an image for the venue!");

    return this.submit();
  }

  error(st: string) {
    this.toast.error(st);
  }

  isValid(input: string) {
    return /^[a-zA-Z][a-zA-Z\s\\']*$/.test(input);
  }

  async submit() {
    //Step 0: Instantiate Form Results
    const form = this.form.value;

    //Step 1: Initialize a new city object
    var newVenue: Venue = this.fb.city.initVenue();
    //Step 2: Populate venue attributes that are extracted from form results
    newVenue.name = form["venue_name"];
    newVenue.is_active = form["active"];
    newVenue.redirect = form["redirect"];
    newVenue.redirect_url = form["redirect_url"];
    newVenue.image = this.image;
    newVenue.thumbnail = form["sd"];
    newVenue.description = form["ld"];
    newVenue.rank = this.fb.city.current.active_venues;

    //Step 6: Push to Firestore
    this.fb.city.addVenue(newVenue);

    //Step 7: Close Modal
    this.modalRef.hide();

    //Step 8: Notify User of Successful update
    setTimeout(() => this.toast.success("Venue Updated!"), 2000);
  }

  async selectImage(event) {
    this.image = await this.fb.saveImage(
      event.target.files[0],
      "venue_images/"
    );
  }
}
